import _ from 'lodash';

import { mapGetters } from 'vuex';

/**
 * Base test data
 *
 * @type  {Object}
 */
const baseTestData = {
    disabled: false,
    presentAsListed: true,
    relatedTableName: 'users',
    id: 'testId',
    name: 'testName',
    value: null,
    defaultValue: null,
    label: 'Test Label',
    mutation: 'testing/DEFAULT_TEST_MUTATION',
    tooltip: 'Testing the Tooltip.',
    vueComponent: 'ManyToOne',
};
export default {
    data() {
        return {
            /**
             * An object sent to child components; used to signal that the fields need to be reset, with the ability
             * to limit the reset to only certain fields
             *
             * @type  {Object}
             */
            formFieldsReset: {
                /**
                 * A list of field names to include in a reset action
                 *
                 * @type  {Array}
                 */
                includeFields: [],

                /**
                 * A parameter that is listened by the child components. Changed via moment().valueOf() method to always
                 * set the fresh value.
                 *
                 * @type  {integer}
                 */
                resetData: null,
            },

            /**
             * Tests
             *
             * @type  {Object}
             */
            tests: {
                testDefaultSettings: {
                    ...baseTestData,
                },

                testDisabled: {
                    ...baseTestData,
                    disabled: true,
                },

                testValue: {
                    ...baseTestData,
                    value: { id: 2 },
                },

                testDefaultValue: {
                    ...baseTestData,
                    defaultValue: 1,
                },
            },

            /**
             * Selected test data
             *
             * @type  {Object}
             */
            test: {},
        };
    },

    /**
     * Set the computed property
     *
     * @type  {Object}
     */
    computed: {
        ...mapGetters({
            testingState: 'testing/testing',
        }),

        /**
         * Toggles the tested component
         *
         * @return  {boolean}
         */
        showComponent() {
            return !_.isEmpty(this.test);
        },
    },

    /**
     * Set the mounted hook
     *
     * @return  {void}
     */
    mounted() {
        this.test = this.tests[this.$route.params.test];
    },
};
